const deck = document.getElementById("inspire-deck");
const restartButton = document.getElementById("restartBtn");
const selectionArea = document.getElementById("selectionArea");
const instructions = document.getElementById("inspire-instructions");
let cards = [];
let isShuffling = false;
let selectionMade = false;

const metaObjectsCards = JSON.parse(document.getElementById('metaobjects-dwcards-json').textContent);

var currentCards = [];

(function() 
{
  if($('#btn-newsletter').length > 0)
  {
    $('#btn-newsletter').on('click', function (e) {
      e.preventDefault();
      $(".error_name").css("display", "none");
      $(".error_server").css("display", "none");
      var customerName = $.trim($("#contact_name").val());
      if(customerName == "")
      {
        $(".error_name").css("display", "block");
      }
      else{
        $('#btn-newsletter').addClass("loading");
        $('#btn-newsletter').attr('disabled','disabled');
        try {
          const response = fetch('https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/newsletter.php', 
          {
            method: "POST",
            body: JSON.stringify({
              id: window.inspire_cta.customer_id,
              name: customerName,
              lang: window.inspire_cta.lang
            })
          });
          response.then(res => {
            return res.json();
          })
          .then(res => {
            $('#btn-newsletter').removeAttr('disabled');
            $('#btn-newsletter').removeClass("loading");
            if(res.status){
              window.location.href = window.location.href;
            }
            else{
              $(".error_server").css("display", "block");
            }
            
          });
        } catch (error) {
            $('#btn-newsletter').removeAttr('disabled');
            $('#btn-newsletter').removeClass("loading");
            $(".error_server").css("display", "block");
        }
      }
    });
  }
})();

function createDeck() {
  for (let i = 0; i < 35; i++) {
    const card = document.createElement("div");
    card.className = "inspire-card card-pattern deck-shadow";
    //card.style.transform = `translateZ(${i * 0.5}px)`;

    card.setAttribute('data-index', i);

    const zIndex = 35 - i;
    const rotate = (i * 0.7) - 15;
    const translateX = ((i % 5) - 2.5) * 2;
    const translateY = ((i % 3) - 1.5) * 2;

    card.style.zIndex = zIndex;
    card.style.transform = `rotate(${rotate}deg) translate(${translateX}px, ${translateY}px)`;



    const cardBack = document.createElement("div");
    cardBack.className = "card-back card-pattern";
    
    const cardFront = document.createElement("div");
    cardFront.className = "card-front";

    card.appendChild(cardBack);
    card.appendChild(cardFront);
    deck.appendChild(card);
    cards.push(card);
  }
}

/* function shuffleCards() {
  if (isShuffling) return;
  isShuffling = true;
  instructions.textContent = "Shuffling...";

  cards.forEach((card, index) => {
    card.classList.add('add-shadow');
    card.classList.remove('deck-shadow');
    const delay = index * 30;
    setTimeout(() => {
      const randomX = (Math.random() - 0.5) * 100;
      const randomY = (Math.random() - 0.5) * 100;
      const randomRotate = (Math.random() - 0.5) * 40;
      card.style.transition = "transform 0.4s ease, opacity 0.4s ease";

      card.style.transform = `translate(${randomX}px, ${randomY}px) rotate(${randomRotate}deg)`;

      
      setTimeout(() => {
        card.style.transform = `translateZ(${index * 0.5}px)`;
        card.classList.remove('add-shadow');
      }, 400);
    }, delay);
  });

  setTimeout(() => {
    showSelection();
  }, 2000);
} */

function shuffleCards() {
    if (isShuffling) return;
    isShuffling = true;
    instructions.textContent = window.inspire_cta.shuffling;
    deck.classList.add('shuffling');

    // First phase - cards spread out in realistic arcs
    cards.forEach((card, index) => {
        card.classList.add('add-shadow');
        card.classList.remove('deck-shadow');
        
        const delay = index * 25; // Staggered timing
        
        setTimeout(() => {
            // Determine shuffle pattern based on card position
            const shuffleType = getShuffleType(index);
            const animationDuration = 1.2 + (Math.random() * 0.4); // Vary duration slightly
            
            card.style.transition = `transform ${animationDuration}s cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
            card.style.animation = `${shuffleType} ${animationDuration}s cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
            
        }, delay);
    });

    // Second phase - cards settle back into deck
    setTimeout(() => {
        cards.forEach((card, index) => {
            const settleDelay = index * 15;
            
            setTimeout(() => {
                card.style.animation = '';
                card.style.transition = 'transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)';
                
                // Shuffle the order slightly
                const newIndex = (index + Math.floor(Math.random() * 10) - 5 + cards.length) % cards.length;
                const zIndex = 35 - newIndex;
                const rotate = (newIndex * 0.5) - 15 + (Math.random() - 0.2) * 4;
                const translateX = ((newIndex % 5) - 2.5) * 2 + (Math.random() - 0.5) * 3;
                const translateY = ((newIndex % 3) - 1.5) * 2 + (Math.random() - 0.5) * 3;
                
                card.style.zIndex = zIndex;
                card.style.transform = `rotate(${rotate}deg) translate(${translateX}px, ${translateY}px)`;
                
                setTimeout(() => {
                    card.classList.remove('add-shadow');
                    card.classList.add('deck-shadow');
                }, 400);
            }, settleDelay);
        });
    }, 1500);

    // Reset everything
    setTimeout(() => {
        deck.classList.remove('shuffling');
        instructions.textContent = window.inspire_cta.click_shuffle;
        isShuffling = false;
        
        cards.forEach(card => {
            card.style.transition = "all 0.5s ease-out";
        });

  showSelection();
      
    }, 3000);


}

function getShuffleType(index) {
    // Create variety in shuffle patterns
    const patterns = ['shuffle-left', 'shuffle-right', 'shuffle-center', 'shuffle-high'];
    const weights = [0.3, 0.3, 0.25, 0.15]; // Different probabilities for each pattern
    
    // Some cards go higher, some go to sides, some stay more centered
    if (index % 7 === 0 || index % 11 === 0) {
        return 'shuffle-high';
    } else if (index % 3 === 0) {
        return 'shuffle-left';
    } else if (index % 3 === 1) {
        return 'shuffle-right';
    } else {
        return 'shuffle-center';
    }
}

function showSelection() {
  deck.style.transition = "opacity 0.5s ease, transform 0.5s ease";
  deck.style.opacity = "0";
  deck.style.transform = "scale(0.8)";

  if("vibrate" in navigator) {
    navigator.vibrate(1000);
  }

  setTimeout(() => {
    deck.style.display = "none";
    selectionArea.classList.remove("hidden");
    selectionArea.style.display = "flex";
    selectionArea.style.opacity = "0";

    for (let i = 0; i < 3; i++) {
      const selectionCard = document.createElement("div");
      selectionCard.className = "inspire-card selection-card";

      const randomCardIndex = Math.floor(Math.random() * cards.length);
      const cardBack = cards[randomCardIndex].querySelector(".card-back").cloneNode(true);
      const cardFront = cards[randomCardIndex].querySelector(".card-front").cloneNode(true);
      selectionCard.appendChild(cardBack);
      selectionCard.appendChild(cardFront);
      selectionArea.appendChild(selectionCard);
      selectionCard.addEventListener("click", handleCardSelection);
    }

    selectionArea.style.opacity = "1";
    const selectionCards = selectionArea.querySelectorAll(".selection-card");
    selectionCards.forEach((card, index) => {
      setTimeout(() => {
        card.style.transition = "opacity 0.5s ease, transform 0.5s ease";
        card.style.opacity = "1";
        //card.style.transform = "translateY(0)";
      }, index * 200);
    });
    instructions.textContent = window.inspire_cta.choose_card;
    isShuffling = false;
  }, 500);
}

function handleCardSelection(event) {
  if (selectionMade) 
    return;
  selectionMade = true;

  const selectedCard = event.currentTarget;
  const selectionCards = selectionArea.querySelectorAll(".selection-card");
  selectionCards.forEach((card) => 
  {
    if (card !== selectedCard) 
    {
      card.style.transition = "opacity 0.5s ease, transform 0.5s ease";
      card.style.opacity = "0";
      card.style.transform = "scale(0.8) translateY(50px)";
      card.classList.add("hide");
    }
    else if (card === selectedCard) 
    {
      card.classList.add("flipped-permanent");
    }
  });
  
  var randomProduct = metaObjectsCards[Math.floor(Math.random() * metaObjectsCards.length)];
  var motivation = randomProduct.image_en;
  if(window.inspire_cta.lang == 'pt-BR')
    motivation = randomProduct.image_pt;

  
  saveCardSelection(randomProduct.id);

  currentCards.unshift({
    id: randomProduct.id,
    title: randomProduct.title,
    image_pt: randomProduct.image_pt,
    image_en: randomProduct.image_en,
    text: randomProduct.text
  });
  
  
  if(currentCards.length < 3)
  {
    selectedCard.style.transition = "all 0.8s ease";
    selectedCard.classList.add("hide-alone");
    setTimeout(() => 
    {
      selectedCard.querySelector(".card-front").style.backgroundImage = 'url("' + motivation + '")';
      selectedCard.querySelector(".card-front").style.opacity = "1";
      instructions.textContent = window.inspire_cta.card_reveals;
      selectedCard.classList.add("flipped");
    }, 600);
  
    setTimeout(() => {
      
      instructions.innerHTML = window.inspire_cta.card_revealed;
      restartButton.classList.add("show");
      document.getElementById("restartBtn").addEventListener("click", restartGame);
    }, 1500);
  }
  else{
    showCurrentCards();
  }
}

function saveCardSelection(card_id)
{
  try 
  {
    const response = fetch('https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/dw-cards.php', 
    {
      method: "POST",
      body: JSON.stringify(
      {
        customer_id: window.inspire_cta.customer_id, 
        card_id: card_id,
        lang: window.inspire_cta.lang
      })
    });
    response.then(res => {})
    .then(res => {});
  } catch (error) {
  }  
}

function restartGame() {
  selectionArea.innerHTML = "";
  selectionArea.style.display = "none";
  selectionArea.classList.add("hidden");

  restartButton.classList.remove("show");

  deck.innerHTML = "";
  deck.style.display = "block";
  deck.style.opacity = "1";
  deck.style.transform = "scale(1)";
  cards = [];
  isShuffling = false;
  selectionMade = false;
  instructions.textContent = window.inspire_cta.touch_shuffle;
  createDeck();
}

function getValidCard(){
  try 
  {
    const response = fetch('https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/cards.php', 
    {
      method: "POST",
      body: JSON.stringify({
        customer_id: window.inspire_cta.customer_id,
        lang: window.inspire_cta.lang
      })
    });
    response.then(res => {
      return res.json();
    })
    .then(res => 
    {
      if(res.status)
      {
        currentCards = [];
        var nowDate = new Date();
        for (let i = 0; i < res.data.length; i++) {
          var item = res.data[i];
          var d = Date.parse(item.viewedAt);
          if((nowDate.getTime() - d) < (1000*60*60*24))
          {
            let el = metaObjectsCards.find((element) => parseInt(element.id) == parseInt(item.id));
            if(el != undefined)
            {
              currentCards.push({
                id: el.id,
                title: el.title,
                image_pt: el.image_pt,
                image_en: el.image_en,
                text: el.text
              });
            }
          }
        }
        
        if(currentCards.length < 3)
        {
          createDeck();
          if($("#selectionArea").length > 0){
            deck.addEventListener("click", shuffleCards);
          }
          else
          {
            $("#inspire-deck").css("pointer-events", "none");
          }
        }
        else{
          showCurrentCards();
        }
      }
      else{
          createDeck();
          if($("#selectionArea").length > 0){
            deck.addEventListener("click", shuffleCards);
          }
          else
          {
            $("#inspire-deck").css("pointer-events", "none");
          }    
      }
    });
  } catch (error) {
    createDeck();
    if($("#selectionArea").length > 0){
      deck.addEventListener("click", shuffleCards);
    }
    else
    {
      $("#inspire-deck").css("pointer-events", "none");
    }    
  }
}

function showCurrentCards() {
  
  var image0 = currentCards[0].image_en;
  var image1 = currentCards[1].image_en;
  var image2 = currentCards[2].image_en;
  
  if(window.inspire_cta.lang == 'pt-BR'){
    image0 = currentCards[0].image_pt;
    image1 = currentCards[1].image_pt;
    image2 = currentCards[2].image_pt;
  }
  $("#showArea").empty();
  $("#selectionArea").empty();
  $("#selectionArea").addClass("hidden");
  instructions.textContent = window.inspire_cta.cards_limit;
  $("#inspire-deck").addClass("hidden");
  $("#showArea").removeClass("hidden");
  $("#showArea").append(`<div class="inspire-card selection-card flipped-permanent">
                                <div class="card-back card-pattern"></div>
                                <div class="card-front" style="background-image: url(` + image0 + `);""></div><span>1</span>
                              </div>`);
  $("#showArea").append(`<div class="inspire-card selection-card flipped-permanent">
                                <div class="card-back card-pattern"></div>
                                <div class="card-front" style="background-image: url(` + image1 + `);""></div><span>2</span>
                              </div>`);
  $("#showArea").append(`<div class="inspire-card selection-card flipped-permanent">
                                <div class="card-back card-pattern"></div>
                                <div class="card-front" style="background-image: url(` + image2 + `);""></div><span>3</span>
                              </div>`);
}

(function() 
{
  getValidCard();

  if(document.getElementById("inspireDisabled")){
    initializeLoginModal();
  }
})();



// Function to handle login modal functionality
function initializeLoginModal() {
    const inspireDisabled = document.getElementById("inspireDisabled");
    const needsLoginModal = document.getElementById("needsLoginModal");
    const loginBtn = document.getElementById("loginBtn");
    const cancelLoginBtn = document.getElementById("cancelLoginBtn");
  
    // Show login modal when disabled form is clicked
    if (inspireDisabled) {
      inspireDisabled.addEventListener("click", () => {
        if (needsLoginModal) {
          needsLoginModal.classList.add("show");
        }
      });
    }
  
    // Handle cancel button click
    if (cancelLoginBtn) {
      cancelLoginBtn.addEventListener("click", () => {
        if (needsLoginModal) {
          needsLoginModal.classList.remove("show");
        }
      });
    }
  }
  